import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

const SECRET =  environment.LS_SECRET;

export const encrypt = (message: unknown): string | void => {
  const messageToEncrypt = (typeof message === 'string') ? message : JSON.stringify(message);
  return CryptoJS.RC4.encrypt(messageToEncrypt, SECRET).toString();
};

export const decrypt = (encryptedMessage: string): string => {
  let decrypted;

  try {
    const bytes = CryptoJS.RC4.decrypt(encryptedMessage, SECRET);
    decrypted = bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    return '';
  }

  try {
    return JSON.parse(decrypted);
  } catch (e) {
    return decrypted;
  }
};
